export default __webpack_public_path__ + "9b0133d3be9b5170c6e3598e3e686e2f.png";